/**
 * Text annotation extension handler.
 *
 * Stores note content in annotation_data with field_key='text'.
 */
import { BaseExtensionHandler } from "../_base.ts"
import type { ExtensionManifest, SerializedAnnotation, StoredAnnotation } from "../_interface.ts"
import { createTextSchema, textConfigSchema, updateTextSchema } from "./schema.ts"

export class TextHandler extends BaseExtensionHandler {
  readonly type = "text"
  readonly manifest: ExtensionManifest = {
    type: "text",
    label: "Text Note",
    scope: "case",
    storage: "structured",
    supportsLinking: false
  }

  getConfigSchema() {
    return textConfigSchema
  }

  getCreateSchema() {
    return createTextSchema
  }

  getUpdateSchema() {
    return updateTextSchema
  }

  serializeForDb(apiData: unknown): SerializedAnnotation {
    const data = apiData as {
      value_text?: string
    }

    return {
      annotation: {},
      data: data.value_text === undefined ? [] : [{ field_key: "text", value_text: data.value_text }],
      files: []
    }
  }

  deserializeFromDb(stored: StoredAnnotation): unknown {
    const textValue = stored.data.find((d) => d.field_key === "text")?.value_text ?? ""

    return {
      id: stored.annotation.id,
      submission_id: stored.annotation.submission_id,
      project_module_id: stored.annotation.project_module_id,
      series_id: stored.annotation.series_id,
      value_text: textValue,
      created_at: stored.annotation.created_at,
      updated_at: stored.annotation.updated_at
    }
  }

  getExportColumns(_templateSchema: unknown): string[] {
    return ["text_value"]
  }

  toExportRow(annotations: StoredAnnotation[], _templateSchema: unknown): Record<string, string | number> {
    const values = annotations
      .flatMap((a) => a.data.filter((d) => d.field_key === "text" && d.value_text).map((d) => d.value_text as string))
      .filter((v) => v.length > 0)

    return {
      text_value: values.join("|")
    }
  }
}
